import React from 'react';

const NewEvent = () => {
    return (
        <div className="container my-5">
            <div className="text-center my-3">
                <h2>Upcoming Events</h2>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{"width": "150px", "height": "4px"}} ></hr>
            </div>
            <div class="row row-cols-1 row-cols-md-3 g-4">
                <div class="col">
                    <div class="card h-100 card-hover">
                        <img src="https://www.knoebels.com/data/uploads/media/image/Bingo400x333.jpg?w=400" class="card-img-top" alt="..."/>
                        <div class="card-body">
                            <h5 class="card-title">Hallo-Fun Activities!</h5>
                            <h6 className="text-muted">Oct 31, 2021</h6>
                            <p class="card-text">Join the Boo Crew Saturday and Sunday mornings for some extra festive "Pre-Opening" Hallo-Fun activities!</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100 card-hover">
                    <img src="https://www.knoebels.com/data/uploads/media/image/Hallofun-400x333.jpg?w=400" class="card-img-top" alt="..."/>
                    <div class="card-body">
                        <h5 class="card-title">Hallo-Fun</h5>
                        <h6 className="text-muted">Oct 22, 2021</h6>
                        <p class="card-text">Knoebels transforms into a spooktacular place for ghost and ghouls of all ages.</p>
                    </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card h-100 card-hover">
                    <img src="https://www.knoebels.com/data/uploads/media/image/Copy-of-Copy-of-Trivia.png?w=400" class="card-img-top" alt="..."/>
                    <div class="card-body">
                        <h5 class="card-title">Trivia Night</h5>
                        <h6 className="text-muted">Oct 5, 2021</h6>
                        <p class="card-text">Grab your friends and join us for Trivia Night!</p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewEvent;